module.exports = __webpack_public_path__ + "static/media/Spiderman.c63596fb.png";